document.addEventListener('DOMContentLoaded', () => {
    // Initialize all sliders
    document.querySelectorAll('.product-meta-slider-swiper').forEach((slider, index) => {
        const swiperInstance = new Swiper(slider, {
            loop: false,
            navigation: {
                // Use the parent slider container and target the navigation buttons within it
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            on: {
                slideChange: function () {
                    const nextButton = slider.querySelector('.swiper-button-next');
                    const prevButton = slider.querySelector('.swiper-button-prev');

                    // Ensure buttons exist before changing their style
                    if (nextButton && prevButton) {
                        if (swiperInstance.isBeginning) {
                            prevButton.style.display = 'none';  // hide "prev" button when on the first slide
                            nextButton.style.display = 'flex';  // show "next" button
                        } else if (swiperInstance.isEnd) {
                            nextButton.style.display = 'none';  // hide "next" button when on the last slide
                            prevButton.style.display = 'flex';  // show "prev" button
                        } else {
                            nextButton.style.display = 'flex';  // show both buttons in the middle
                            prevButton.style.display = 'flex';
                        }
                    }
                },
            },
        });

        // Initial state adjustments (hide "prev" button on the first slide)
        const prevButton = slider.querySelector('.swiper-button-prev');
        if (prevButton) {
            prevButton.style.display = 'none';  // hide "prev" button on the first slide
        }
    });
});
